import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';
import styled from 'styled-components';
import { isMobile } from 'app/helpers/utils';
import { Flex, Box } from '@rebass/grid';

const StepsContainer = styled(({ step, parentXPadding, children, ...rest }) => (
  <Box {...rest}>{children}</Box>
))`
  text-align: center;
  transition: all ease 1s, border: 1ms;
  ${({ parentXPadding, step }) =>
    isMobile &&
    `
      width: 100vw;
      margin-left: -${parentXPadding};
      margin-right: -${parentXPadding};
      ${step === 0 ? 'height:0;' : 'border-top: 1px solid #eee;'}
    `};
`;

const Steps = ({ numSteps, step, parentXPadding, width }) => (
  <StepsContainer width={width} parentXPadding={parentXPadding} step={step}>
    <Flex pt={[30, 25]} pb={[10, 0]}>
      <Step
        width={ 1 / numSteps}
        complete={step > 1}
        current={step === 1}
        inactive={step === 0}
      >
        Submit Website
      </Step>
      <Step
        width={ 1 / numSteps}
        complete={step > 2}
        current={step === 2}
        inactive={step === 0}
      >
        Review Results
      </Step>
      {numSteps === 3 && (<Step
        width={1 / 3}
        complete={step > 3}
        current={step === 3}
        inactive={step === 0}
      >
        Take Action
      </Step>)}
    </Flex>
  </StepsContainer>
);

Steps.propTypes = {
  width: PropTypes.array.isRequired,
  step: PropTypes.number.isRequired,
  parentXPadding: PropTypes.string.isRequired,
  numSteps: PropTypes.number
};

export default Steps;
